module.exports = __webpack_public_path__ + "static/media/email.cce7fe25.svg";